import { render, staticRenderFns } from "./CustomCalendar.vue?vue&type=template&id=665b6b6a&scoped=true&"
import script from "./CustomCalendar.vue?vue&type=script&lang=js&"
export * from "./CustomCalendar.vue?vue&type=script&lang=js&"
import style0 from "./CustomCalendar.vue?vue&type=style&index=0&id=665b6b6a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "665b6b6a",
  null
  
)

export default component.exports